import {
  createRootRoute,
  createRoute,
  createRouter,
} from "@tanstack/react-router";
import { ConsoleShell } from "./shell";
import { OverviewPage } from "./pages/Overview";
import { SitesPage } from "./pages/Sites";
import { LodgifyIntegrationPage } from "./pages/LodgifyIntegration";

const rootRoute = createRootRoute({ component: ConsoleShell });

const overviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: OverviewPage,
});

const sitesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sites",
  component: SitesPage,
});

const lodgifyIntegrationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/organizations/$organizationId/sites/$siteId/integrations/lodgify",
  component: LodgifyIntegrationPage,
});

const routeTree = rootRoute.addChildren([
  overviewRoute,
  sitesRoute,
  lodgifyIntegrationRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
